import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import * as SIGN_IN_CONFIGURATION_API from '../../constants/api/sign-in-configuration';
import { ISignInConfigurationDAO, ISignInConfigurationDTO } from '../sign-in-configuration.dao';

class SignInConfigurationDAO extends ISignInConfigurationDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getSignInConfiguration(eventId: number, accountId: number): Promise<ISignInConfigurationDTO> {
        const response = await this.apiClient.get<ISignInConfigurationDTO>(SIGN_IN_CONFIGURATION_API.SIGN_IN_CONFIGURATION, {
            accountId: accountId,
            eventId: eventId
        });

        return response.parsedResponse;
    }

    public async updateSignInConfiguration(accountId: number, eventId: number, signInConfiguration: ISignInConfigurationDTO)
        : Promise<ISignInConfigurationDTO> {
        const response = await this.apiClient.put<ISignInConfigurationDTO>(SIGN_IN_CONFIGURATION_API.SIGN_IN_CONFIGURATION, {
            accountId: accountId,
            eventId: eventId,
            ...signInConfiguration
        });
        return response.parsedResponse;
    }
}

export { SignInConfigurationDAO };